import { useState } from "react";
import { AnimationState, MenuTriggerContext } from "./types";
import {
  MenuTriggerProps,
  MenuTrigger as MenuTriggerRAC,
} from "react-aria-components";
import { AnimationDefinition } from "framer-motion";

export default function MenuTrigger(props: MenuTriggerProps) {
  const [currentAnimation, setAnimation] =
    useState<AnimationState>("unmounted");

  const onComplete = (animation: AnimationDefinition) => {
    setAnimation((prevAnimation) =>
      animation === "hidden" && prevAnimation === "hidden"
        ? "unmounted"
        : prevAnimation,
    );
  };

  return (
    <MenuTriggerContext.Provider
      value={{
        currentAnimation,
        onComplete,
      }}
    >
      <MenuTriggerRAC
        {...props}
        onOpenChange={(isOpen) => {
          setAnimation(isOpen ? "visible" : "hidden");
          props.onOpenChange?.(isOpen);
        }}
      />
    </MenuTriggerContext.Provider>
  );
}
